export const ptData = {
  title: 'DECLARAÇÃO SOBRE COOKIES',
  sections: [
    {
      title: 'Como Utilizamos Cookies e TecnologiasSemelhantes',
      content: `

      `
    },
    {
      title: '1. O que são cookies?',
      content: `
<p>Os cookies sãopequenosficheiros de texto transferidos a partir dos nossoswebsites, aplicaçõesouserviços e armazenados no seu dispositivo. Os websites da Danghuan, serviços online, aplicações, serviçosinterativos, e-mails e anúnciospodem utilizar cookies e tecnologiassemelhantes, tais como etiquetas de píxel (pixel tags) e web beacons.Não podemos aceder a cookies que nãotenham sido definidos pelos nossoswebsitesouserviços.</p>

      `
    },
    {
      title: '2. Durante quanto tempo permanecem os cookies no seu dispositivo?',
      content: `
<p><strong>(1) Cookies de sessão</strong></p>
<p>Estes cookies permanecem apenas até fechar o navegador e nãosãoarmazenados permanentemente no seu dispositivo. Os cookies de sessãosãogeralmente utilizados para acompanhar as páginas que visita durante umasessão de navegação, de modo a personalizar a suaexperiência durante essa visita.</p>
<p><strong>(2) Cookies persistentes</strong></p>
<p>Estes cookies permanecemarmazenados no seu dispositivo até serem eliminados manualmente ou até expiraremautomaticamente. Os cookies persistentes podem ser utilizados para memorizar as suaspreferênciasquandovoltar a visitar o nossowebsite.</p>

      `
    },
    {
      title: '3. Utilizamos os seguintes tipos de cookies',
      content: `
<p><strong>(1) Cookies estritamentenecessários</strong></p>
<p>Estes cookies sãonecessários para o funcionamento do nossowebsite e dos nossosserviços. Podem incluir cookies que permitem o acesso a áreas seguras do website, mantêmsessõesouajudam a prevenir atividades fraudulentas.</p>
<p><strong>(2) Cookies analíticos ou de desempenho</strong></p>
<p>Estes cookies permitem-nos contabilizar o número de visitantes e compreender de que forma os utilizadores interagemcom o nossowebsite, para que possamosmelhorar o seudesempenho, funcionalidade e experiência do utilizador.</p>
<p><strong>(3) Cookies funcionais</strong></p>
<p>Estes cookies permitemreconhecê-lo quandoregressaaonossowebsite e permitem-nos personalizar conteúdos e memorizar as suaspreferências, como a seleção do idioma.</p>
<p><strong>(4) Cookies de publicidadecomportamental</strong></p>
<p>Estes cookies registam a sua visita aonossowebsite, as páginas que visita e as ligações em que clica.Podemos utilizar estas informações para tornar o nossowebsite e os anúnciosmais relevantes para os seusinteresses. Podemos tambémpartilhar estas informaçõescomterceiros para finspublicitários, quando legalmente permitido.</p>

      `
    },
    {
      title: '4. Como utilizamos os cookies',
      content: `
<p>(1) Nós e os nossosparceiros podemos utilizar cookies e tecnologiassemelhantes para compreendermelhor o funcionamento do nossowebsite, serviços e plataformas móveis, incluindo:</p>
<ul>
  <li>a frequênciacom que os nossosserviçossão utilizados;</li>
  <li>o comportamento de navegação;</li>
  <li>dados técnicos e de desempenho;</li>
  <li>fontes de tráfego;</li>
  <li>interações com anúncios;</li>
  <li>informações sobre o dispositivo e o navegador.</li>
</ul>
<p>Nãoassociamosdiretamente os dados provenientes de cookies analíticos a informações de identificaçãopessoal, salvo quando tal seja permitido por lei.</p>
<p>(2) Nós e os nossosparceiros podemos utilizar cookies e tecnologiassemelhantes para analisartendências, administrar websites, monitorizar a atividade dos utilizadores e recolherinformações demográficas agregadas sobre a nossa base de utilizadores.</p>
<p>(3) Se a funcionalidade “Do Not Track” (“Não Rastrear”) estiverativada no seu navegador, respeitaremos as configurações do seu navegador quando tal for legalmente exigido.</p>
<p>(4) Tal como acontece com a maioria dos websites, recolhemosautomaticamente determinadas informações técnicas, incluindo:</p>
<ul>
  <li>endereço IP;</li>
  <li>tipo de navegador;</li>
  <li>fornecedor de serviços de Internet;</li>
  <li>páginas de referência e de saída;</li>
  <li>ficheiros e páginasvisualizados;</li>
  <li>sistemaoperativo;</li>
  <li>data e hora;</li>
  <li>dados relativos à sequência de cliques (clickstream).</li>
</ul>
<p>(5) Podemos colaborar com prestadores externos de serviços de publicidade e análise para apresentaranúncios no nossowebsiteougeriranúncios em websites de terceiros.</p>
<p>Estesparceirospodem utilizar cookies outecnologiassemelhantes para fornecer publicidadecom base nassuasatividades de navegação e interesses.</p>
<p>Pode geriroudesativar os cookies de publicidadeatravés das configurações do seu navegador ou das preferências de cookies.</p>
<p>Tenha em atenção que desativar a publicidade personalizada não significa que deixará de visualizar anúncios.</p>

      `
    },
    {
      title: '5. Eliminaroudesativar cookies',
      content: `
<p>Pode gerir as suaspreferências de cookies através das configurações do seu navegador ou do nosso banner de cookies.</p>
<p>Consulte as instruções fornecidas pelo seu navegador para saber comogerir os cookies, incluindo:</p>
<ul>
  <li>Microsoft Internet Explorer</li>
  <li>Microsoft Edge</li>
  <li>Mozilla Firefox</li>
  <li>Google Chrome</li>
  <li>Safari for macOS</li>
  <li>Safari for iOS</li>
</ul>
<p>Tenha em atenção que a desativação dos cookies poderáafetar o funcionamento de determinadas partes dos nossosServiços.</p>

      `
    },
    {
      title: '6. Informaçõesadicionaissobre cookies',
      content: `
<p>Para obtermaisinformações sobre cookies e sobre como configurar o seu navegador para aceitar, rejeitarou eliminar cookies, consulte o websiteAllAbout Cookies.</p>
<p>Consulte também a nossaPolítica de Privacidade para obterinformaçõesadicionais sobre o tratamento dos seus dados pessoais.</p>
<p>Detalhes dos Cookies</p>
<p>A tabelaseguinteapresentaexemplos de cookies que podem ser utilizados no nossowebsite<a href="https://<a href="https://www.danghuan.eu:"" target="_blank">www.danghuan.eu:"</a> target="_blank">https://<a href="https://www.danghuan.eu:" target="_blank">www.danghuan.eu:</a></a></p>

        <table>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Nome</th>
              <th>Domínio / Fornecedor</th>
              <th>Finalidade</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Necessário</td>
              <td>session_id</td>
              <td>danghuan.eu</td>
              <td>Mantém a sessão do utilizador e aautenticação</td>
            </tr>
            <tr>
              <td>Necessário</td>
              <td>cookiesaccepted</td>
              <td>danghuan.eu</td>
              <td>Armazena as preferências de consentimento de cookies</td>
            </tr>
            <tr>
              <td>Necessário</td>
              <td>XSRF-TOKEN</td>
              <td>danghuan.eu</td>
              <td>Segurança e prevenção de fraude</td>
            </tr>
            <tr>
              <td>Necessário</td>
              <td>stayOnSite</td>
              <td>danghuan.eu</td>
              <td>Memoriza a seleção da regiãooudo website</td>
            </tr>
            <tr>
              <td>Funcional</td>
              <td>language_pref</td>
              <td>danghuan.eu</td>
              <td>Armazena as preferências de idioma</td>
            </tr>
            <tr>
              <td>Analítico</td>
              <td>_ga</td>
              <td>Google Analytics</td>
              <td>Distingue utilizadores e analisa o tráfego</td>
            </tr>
            <tr>
              <td>Analítico</td>
              <td>_gid</td>
              <td>Google Analytics</td>
              <td>Distingue utilizadores</td>
            </tr>
            <tr>
              <td>Analítico</td>
              <td>_gat</td>
              <td>Google Analytics</td>
              <td>Regula a frequência dos pedidos</td>
            </tr>
            <tr>
              <td>Analítico</td>
              <td>_hjSession</td>
              <td>Hotjar</td>
              <td>Análise do website e mapas de calor</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>_fbp</td>
              <td>Meta/Facebook</td>
              <td>Publicidade e acompanhamento de conversões</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>fr</td>
              <td>Meta/Facebook</td>
              <td>Relevância e apresentação de publicidade</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>personalisation_id</td>
              <td>X (Twitter)</td>
              <td>Publicidade e identificação do utilizador</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>_ttp</td>
              <td>TikTok</td>
              <td>Publicidade e rastreamento do utilizador</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>test_cookie</td>
              <td>DoubleClick</td>
              <td>Otimização de publicidade</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>IDE</td>
              <td>DoubleClick</td>
              <td>Publicidadepersonalizada</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>ANID</td>
              <td>Google</td>
              <td>Preferências de publicidade</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>AID</td>
              <td>Google Ads</td>
              <td>Análise e publicidade</td>
            </tr>
            <tr>
              <td>Publicidade</td>
              <td>g</td>
              <td>SmartNews Ads</td>
              <td>Publicidadepersonalizada</td>
            </tr>
          </tbody>
        </table>
      `
    },
    {
      title: '7. Gestão deCookies',
      content: `
<p>Pode configurar o seu navegador para bloquear os cookies ou para o notificar sobre a utilização de cookies. No entanto, se desativar determinados cookies, algumas partes do nossowebsiteou dos nossosserviçospoderãonão funcionar corretamente.</p>
<p>Pode tambémgerir as suaspreferências de cookies através do nosso banner de cookies ou das configurações de privacidade, quandodisponíveis.</p>

      `
    }
  ]
};
